import { Breadcrumbs } from "components/breadcrumbs";
import { useCreate } from "@refinedev/core";
import { FullScreenLoading } from "components/fullScreenLoading";
import toast from "react-hot-toast";
import { IPickupAccountForm, IPickupAccountItem, PickupAccountType } from "interfaces";
import { useNavigate } from "react-router-dom";
import { PickupAccountForm } from "./components";
import { get } from "lodash";
import { formattedFilterParamsString } from "providerrs";
import { useState } from "react";
import Button from "components/button";
import { ImportPickupAccount } from "./components/importPickupAccount";

export const CreatePickupAccount: React.FC = () => {

  const { mutate, isLoading: isLoading } = useCreate();
  const navigate = useNavigate();
  const [creationMethod, setCreationMethod] = useState<"manual" | "import">("manual");
  const [importBusy, setImportBusy] = useState(false);

  const onSubmit = (values: IPickupAccountForm) => {
    const submitValues = { ...values };
    mutate(
      {
        resource: "pickup/accounts",
        meta: {
          ignoreResourceWrapper: true,
        },
        values: {
          ...submitValues,
        },
      },
      {
        onSuccess: (data) => {
          const accountData = get(data, "data.data", null) as IPickupAccountItem;
          toast.success("Create successfully");
          navigate(`/pickup/accounts?${formattedFilterParamsString([
            {
              field: "account_type", 
              operator: "eq", 
              value: (get(accountData, "role_name", "") || PickupAccountType.POS).toLowerCase()
            }
          ])}`);
        },
      }
    );
  };

  return (
    <div className="wrapper">
      <Breadcrumbs customPageLabel="Create Pickup Account" />
      <div className="mb-4 flex gap-2" role="group" aria-label="Account creation method">
        <Button
          aria-pressed={creationMethod === "manual"}
          disabled={importBusy || isLoading}
          className={creationMethod === "manual" ? "" : "bg-white text-brand-500 border border-brand-500 hover:bg-gray-50 active:bg-gray-100"}
          onClick={() => setCreationMethod("manual")}
        >Create manually</Button>
        <Button
          aria-pressed={creationMethod === "import"}
          disabled={importBusy || isLoading}
          className={creationMethod === "import" ? "" : "bg-white text-brand-500 border border-brand-500 hover:bg-gray-50 active:bg-gray-100"}
          onClick={() => setCreationMethod("import")}
        >Import from Excel / CSV</Button>
      </div>
      <div className="w-full min-w-0" hidden={creationMethod !== "manual"}>
        <PickupAccountForm onSubmit={onSubmit} />
      </div>
      <div className="w-full min-w-0" hidden={creationMethod !== "import"}>
        <ImportPickupAccount onBusyChange={setImportBusy} />
      </div>
      {isLoading ? <FullScreenLoading /> : <></>}
    </div>
  );
};
